import { Box, BoxProps } from "@mui/material";
import { useTranslation } from "next-i18next";
import { createChartImagePreviewUrl } from "src/constants/urls";
import { TImageLoading } from "src/types/image.types";
import { toSxArray } from "src/utils/mui/sx/sx";

export interface IWikifolioOgChartImageProps extends BoxProps {
    wikifolioId: string;
    shortDescription: string;
    ratio?: number;
    loading?: TImageLoading;
    onError?: () => void;
}

export const WikifolioOgChartImage = ({
    wikifolioId,
    ratio = 16 / 9,
    shortDescription,
    loading,
    onError,
    sx,
    ...boxProps
}: IWikifolioOgChartImageProps) => {
    const { t } = useTranslation("common");

    return (
        <Box sx={[{ position: "relative", width: "100%", aspectRatio: ratio, overflow: "hidden" }, ...toSxArray(sx)]} {...boxProps}>
            <Box
                component="img"
                src={createChartImagePreviewUrl(wikifolioId)}
                alt={`${t("wikifolio-chart")}: ${shortDescription}`}
                loading={loading}
                onError={onError}
                sx={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }}
            />
        </Box>
    );
};
